import React from 'react';
import {createRoot} from 'react-dom/client';
import BaseComponent from '@components/base/BaseComponent/BaseComponent';
import styles from './PageTermsAndAgreements.scss';
import {__t} from "../../common/lang/text-resource";
import ComponentTermsBlock from "../../components/ComponentTermsBlock/ComponentTermsBlock";
import pdfImg from './img/pdf.svg';
import {ContextServicePriceProvider} from "@contexts/ContextServicePriceProvider";
import Header from "@components/base/Header/Header";
import {ContextCartProvider} from "@contexts/ContextCartProvider";
import CommonPageHeaderDataShort from "@components/base/Header/data/CommonPageHeaderDataShort";

import '../../common/scss/blueprint-css/_blueprint.scss';
import Footer from "@components/base/Footer/Footer";

class PageTermsAndAgreements extends BaseComponent {

	lang = 'bg';

	constructor() {
		super(...arguments, 'PageTermsAndAgreements');

		this.lang = SHVO.pageLang ?? 'bg';
	}

	componentDidMount() {
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has('password')) {
			window.history.replaceState(null, '', window.location.pathname);
			const element = document.getElementById('gtc_password');
			if (element) {
				const trigger = document.querySelector('#gtc_password a');
				if (trigger) {
					trigger.click();
				}
				setTimeout(() => {
					const rect = element.getBoundingClientRect();
					window.scrollTo({
						top: window.scrollY + rect.top - 250,
						behavior: 'smooth'
					});
				}, 100);
			}
		}
	}


	render() {
		const {
			header,
		} = this.props.data.componentData;


		return (
		  <>
			  <ContextCartProvider>
				  <ContextServicePriceProvider>
					  <Header data={CommonPageHeaderDataShort}/>
				  </ContextServicePriceProvider>
			  </ContextCartProvider>
			  <div className={styles.container}>
				  <h1>{__t('Общи условия за услугите на"СуперХостинг.БГ" ЕООД')}</h1>

				  <ComponentTermsBlock
					id="shared"
					link={__t('-terms-GTC_Shared-Hosting-and-WordPress-hosting-S2e9e32')}
					title={__t('общи-условия-за-предоставяне-на-услугата-споделен5a0e2d')}/>

				  <ComponentTermsBlock
					id="wpai"
					link={__t('/terms/GTC_Managed_WP_hosting_BG.pdf')}
					title={__t('общи-условия-за-предоставяне-на-хостинг-услугата-f8b550')}/>

				  {this.lang === 'bg' && (
					<ComponentTermsBlock
					  id="wpsupport"
					  link={__t('/terms/GTC_professional WordPress support_BG.pdf')}
					  title={__t('общи-условия-за-предоставяне-на-професионална-Wor8bdfd0')}/>
				  )}

				  <ComponentTermsBlock
					id="mvps"
					link={__t('/terms/GTC_Managed VPS_BG.pdf')}
					title={__t('общи-условия-за-използване-на-услугата-управляем-d13944')}/>

				  <ComponentTermsBlock
					id="vps"
					link={__t('/terms/GTC_VPS_BG.pdf')}
					title={__t('Общи условия за Виртуален Сървър (VPS)')}/>

				  <ComponentTermsBlock
					id="dedicated"
					link={__t('/terms/GTC_Dedicated server_BG.pdf')}
					title={__t('Общи условия за Нает сървър (Dedicated server)')}/>

				  {this.lang === 'bg' && (
					<ComponentTermsBlock
					  id="site-builder"
					  link={__t('/terms/GTC_Site builder_BG.pdf')}
					  title={__t('Общи условия за Сайт билдър')}/>
				  )}

				  <ComponentTermsBlock
					id="site-builder-ai"
					link={__t('/terms/GTC_Site_builder_AI_BG.pdf')}
					title={__t('Общи условия за Сайт билдър AI')}/>

				  <ComponentTermsBlock
					id="shopiko"
					link={__t('/terms/GTC_Shopiko_BG.pdf')}
					title={__t('Общи условия за Shopiko')}/>

				  <ComponentTermsBlock
					id="domain"
					link={__t('/terms/GTC_registration and managing domains_BG.pdf')}
					title={__t('Общи условия за регистрация и управление на домейни')}/>

				  <ComponentTermsBlock
					id="certificates"
					link={__t('/terms/GTC_SSL certificates_BG.pdf')}
					title={__t('общи-условия-на-суперхостинг-бг-еоод-за-предостав2e790d')}/>

				  {this.lang === 'bg' && (
					<ComponentTermsBlock
					  id="gdprprotect"
					  link={__t('/terms/GTC_GDPR_protect_BG.pdf')}
					  title={__t('Общи условия за ползване на услугата „GDPR Протект”')}/>
				  )}

				  {this.lang === 'bg' && (
					<ComponentTermsBlock
					  id="supermail"
					  link={__t('/terms/GTC_Supermail_BG.pdf')}
					  title={__t('Общи условия за използване на услугата "СуперМейл"')}/>
				  )}

				  <ComponentTermsBlock
					id="cmailpro"
					link={__t('/terms/GTC_MailPro_BG.pdf')}
					title={__t('общи-условия-за-ползване-на-услугата-бизнес-имейл26c289')}/>

				  {this.lang === 'bg' && (
					<ComponentTermsBlock
					  id="search_engines"
					  link={__t('/terms/GTC_search registration_BG.pdf')}
					  title={__t('Общи условия за регистрация в търсачки')}/>
				  )}

				  <ComponentTermsBlock
					id="icann"
					link={__t('https-www-icann-org-resources-pages-benefits-201386fac3')}
					title={__t('ICANN - Права и задължения на Регистранта')}/>

				  <ComponentTermsBlock
					id="politics"
					link={__t('/terms/Acceptable-Use-Policy-BG.pdf')}
					title={__t('Политики за приемлива употреба')}/>

				  <ComponentTermsBlock
					id="personal_data"
					link={__t('/terms/Privacy-notice-GDPR-BG.pdf')}
					title={__t('задължителна-информация-за-правата-на-лицата-по-з959aa0')}/>

				  <ComponentTermsBlock
					id="personal_data_applicants_partners"
					link={__t('/terms/Privacy-notice-applicants-partners-BG.pdf')}
					title={__t('задължителна-информация-за-правата-на-лицата-по-з629ef0')}/>

				  <ComponentTermsBlock
					id="cookie_policy"
					link={__t('/terms/Cookie-policy-BG.pdf')}
					title={__t('Политика за използване на бисквитки (Cookie Policy)')}/>

				  <ComponentTermsBlock
					id="blogandhelp"
					link={__t('/terms/GTC-blog-and-help-BG.pdf')}
					title={__t('общи-условия-за-използване-на-сайта-www-superhost7bf89d')}/>

				  <ComponentTermsBlock
					id="disputes"
					link={__t('/terms/GTC-Dispute-Resolution-Policy-BG.pdf')}
					title={__t('политика-за-разрешаване-на-спорове-относно-използdb590b')}/>

				  <ComponentTermsBlock
					id="portability"
					link={__t('/terms/Superhosting-EU-Data-Act-Policy-BG.pdf')}
					title={__t('политика-за-преносимост-на-данни-съгласно-регламеf3dd5b')}/>

				  <ComponentTermsBlock
					id="gdpr"
					title={__t('допълнителни-документи-съгласно-регламент-за-защи8a62a2')}>
					  <div>
						  {__t('от-25-05-2018-год-влиза-в-сила-новият-регламент-н4d76fe')}
						  <br/>
						  <br/>
						  <a target="_blank" href={__t('/downloads/superhosting-gdpr.pdf')}
						     className={styles.pdfDownload}>
							  <img src={pdfImg}
							       alt={__t('декларация-за-конфиденциалност-по-смисъла-на-регл000350')}/>
							  {__t('декларация-за-конфиденциалност-по-смисъла-на-регл000350')}
						  </a>
						  <br/>
						  <a target="_blank" href={__t('/downloads/technical-organisational-measures-signed.PDF')}
						     className={styles.pdfDownload}>
							  <img src={pdfImg} alt={__t('Технически и организационни мерки')}/>
							  {__t('Технически и организационни мерки')}
						  </a>
					  </div>
				  </ComponentTermsBlock>

				  <ComponentTermsBlock
					id="domsearch"
					link={__t('/terms/GTC-domain-search-BG.pdf')}
					title={__t('Критерии за класиране на домейните при търсене')}/>

				  <ComponentTermsBlock
					id="password"
					title={__t('Процедура за изгубени или забравени имена и пароли')}>
					  <div>
						  <div>
							  {__t('чл-1-в-случай-че-по-някаква-причина-ползвателят-е77822c')}
							  <br/><br/>
							  {__t('-1-за-повторно-изпращане-на-данни-за-достъп-и-упр8cc39e')}
							  <br/>
							  <a href="web-hosting-client-profile.php" target="_blank"
							     className="bold"> https://my.superhosting.bg/</a>
							  <br/><br/>
							  {__t('-2-ползвателят-може-да-изиска-изпращането-на-даннe7b74f')}
							  <br/><br/>
							  {__t('чл-2-в-случай-че-по-някаква-причина-ползвателят-е68f58f')}
							  <br/><br/>
							  {__t('-1-оригинал-или-копие-заверено-с-вярно-с-оригиналe1bd1d')}
							  <br/><br/>
							  {__t('-2-ако-за-услугите-е-била-издадена-фактура-на-юриe8a491')}
						  </div>
					  </div>
				  </ComponentTermsBlock>
			  </div>
			  <Footer color={'color-brand-orange-400'}/>
		  </>
		)
	}
}

const container = document.getElementById(SHVO.pageAppId);
const root = createRoot(container);
root.render(<PageTermsAndAgreements data={SHVO.pageState} isLazy={'1'}/>);